import script from "./NewWithdraw.vue?vue&type=script&setup=true&lang=js"
export * from "./NewWithdraw.vue?vue&type=script&setup=true&lang=js"

import "./NewWithdraw.vue?vue&type=style&index=0&id=0eafbcdc&scoped=true&lang=css"

import exportComponent from "D:\\xm\\zhongzai\\qianduan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eafbcdc"]])

export default __exports__